<template>
  <div class="body">
    <div class="title">
      消费记录
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
          <el-breadcrumb-item>交易管理</el-breadcrumb-item>
          <el-breadcrumb-item>消费记录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="btnsearch">
      <div class="left">
      </div>
      <div class="right">
        <el-form :inline="true">
          <el-form-item>
            <el-date-picker
              type="date"
              placeholder="提交日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select  placeholder="排序"  style="min-width: 168px;width: 168px" clearable>
              <el-option  name="selected" :value="1" label="创建时间倒序 "></el-option>
              <el-option  name="selected" :value="0" label="支付时间倒序 "></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select  placeholder="支付方式"  style="min-width: 168px;width: 168px" clearable>
              <el-option  name="selected" :value="1" label="全部 "></el-option>
              <el-option  name="selected" :value="0" label="支付宝 "></el-option>
              <el-option  name="selected" :value="0" label="微信支付 "></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select  placeholder="交易状态"  style="min-width: 168px;width: 168px" clearable>
              <el-option  name="selected" :value="1" label="全部 "></el-option>
              <el-option  name="selected" :value="0" label="交易成功 "></el-option>
              <el-option  name="selected" :value="0" label="待支付 "></el-option>
              <el-option  name="selected" :value="0" label="交易失败 "></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="举报信息" style="min-width: 168px;width: 336px;">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <vxe-table
      :data="queryForm"
      :loading="loading"
      border
      stripe
      resizable
      highlight-cell
      highlight-hover-row
      max-height="750"
      class="mytable-scrollbar"
      show-overflow
      keep-source
    >
      <vxe-table-column field="id" title="用户ID" min-width="100">
      </vxe-table-column>
      <vxe-table-column field="title" title="消费用户" min-width="100">
      </vxe-table-column>
      <vxe-table-column field="content" title="消费金额/元" min-width="100">
      </vxe-table-column>
      <vxe-table-column  title="消费类型"
                         min-width="100"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.type === 0">系统推送</el-tag>
          <el-tag   type="warning" v-else-if="scope.row.type === 1">订单消息</el-tag>
        </template>
      </vxe-table-column>
      <vxe-table-column field="user_id" title="总消费/元  " min-width="100">
      </vxe-table-column>
      <vxe-table-column field="item_id" title="订单号/创建时间" min-width="100">
      </vxe-table-column>
      <vxe-table-column field="item_table" title="支付方式" min-width="100">
      </vxe-table-column>
      <vxe-table-column field="statusss"  title="第三方交易号/支付时间" min-width="100">
      </vxe-table-column>
      <vxe-table-column  title="交易状态" min-width="100">
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="200">
        <template slot-scope="scope">
          <!-- 修改按钮 -->
          <button class="btn" @click="xiaofeixiangqing(scope.row)">查看详情</button>
        </template>
      </vxe-table-column>
    </vxe-table>
</div>
</template>

<script>
export default {
  name: 'xiaofeijilu',
  data () {
    return {
      queryForm: [
        {
          id: '1',
          title: 'sss',
          content: 'sasasa',
          user_id: 'sadasdas',
          item_id: 'dsadsa',
          item_table: 'dsadsadsa',
          item_sasaatable: 'dsadsadas',
          statusss: 'sdddd'
        }
      ]
    }
  },
  methods: {
    xiaofeixiangqing () {
      this.$router.push('/xiaofeixiangqing')
    }
  }
}
</script>

<style scoped lang="less">
.body {
  display: flex;
  flex-direction: column;

  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }

    .dsadf {
      color: #3D9AFF;
    }
  }
  .btnsearch{
    display:flex;
    flex-direction: row;
    align-items: center;
    .left{
      margin-right: 150px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .right{
      margin-top: 27px;
    }
  }
  .btn{
    width: 78px;
    height: 37px;
    opacity: 1;
    border: 1px solid rgba(61,154,255,0.50);
    border-radius: 2px;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #3d9aff;
    letter-spacing: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: white;
  }
}
</style>
